import React from "react";
import getThrowIndicator from "./getThrowIndicator";
import { getHoleStyles } from "./ScorecardSummaryHeaderHoleStyles";
import "./ScorecardSummaryRowHoleScoreCell.css"; // Import the CSS file

function ScorecardSummaryCell({ hole, index, throwScoringModeId, maxHole }) {
  const { color, background } = getHoleStyles(index, maxHole);
  const small = false; // Set small to false for now

  const isScoreNull = hole.score === null;

  const throwOneScore = hole.throw_one_score;

  const throwTwoScore = hole.throw_two_score;

  return (
    <td key={index} className="scorecard-summary-cell-outer-td">
      <table className="scorecard-summary-cell-table">
        <tbody>
          <tr>
            <td
              className="scorecard-summary-holeorder-cell"
              style={{
                backgroundColor: background,
                color: color,
                width: "50%",
              }}
            >
              {hole.hole_order}
            </td>
            <td className="scorecard-summary-empty-cell"></td>
            <td className="scorecard-summary-empty-cell"></td>
            <td className="scorecard-summary-top-right-score-cell">
              {throwScoringModeId > 1 && !isScoreNull ? hole.score : ""}
            </td>
          </tr>
          <tr>
            <td
              colSpan={4}
              className={
                small
                  ? "scorecard-summary-hole-score-cell-small"
                  : "scorecard-summary-middle-score-cell"
              }
            >
              {throwScoringModeId > 1 && !isScoreNull
                ? hole.hole_score_adv
                : isScoreNull
                ? "-"
                : hole.score}
            </td>
          </tr>
          <tr
            className={`scorecard-summary-throw-score-cell${
              small ? "-small" : ""
            }`}
          >
            <td colSpan={2} className="scorecard-summary-throw-score-cell">
              {getThrowIndicator(throwOneScore)}
            </td>
            <td colSpan={2} className="scorecard-summary-throw-score-cell">
              {getThrowIndicator(throwTwoScore)}
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  );
}

export default ScorecardSummaryCell;
